import { httpRequest } from "@services/http";

export class CommandDeleteSftpKey {
  // Backend returns a JSON-encoded confirmation string ("deleted").
  async run(organizationId: number, keyId: number): Promise<string> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/sftp/${organizationId}/keys/${keyId}`;
    return await httpRequest<string>(url, { method: "DELETE" });
  }
}
